import { type IncidentPageTableRecord, OIncidentsStatus, OTakedownStatus } from '../types';
import { IncidentCategory } from '@/types/incidents';
import { RouterLinkIncidentParentCategory } from '@/types/router-links';

export const incidentsStatusColorCoding = {
  [OIncidentsStatus.New]: {
    bg: 'var(--incident-new-bg, rgba(230, 19, 66, 0.1))',
    color: 'var(--incident-new-color, #e61342)',
  },
  [OIncidentsStatus.Pending]: {
    bg: 'var(--incident-pending-bg, rgba(0, 64, 255, 0.1))',
    color: 'var(--incident-pending-color, #0040ff)',
  },
  [OIncidentsStatus.Acknowledged]: {
    bg: 'var(--incident-acknowledged-bg, rgba(13, 174, 42, 0.1))',
    color: 'var(--incident-acknowledged-color, #0dae2a)',
  },
  [OIncidentsStatus.Resolved]: {
    bg: 'var(--incident-resolved-bg, rgba(13, 174, 42, 0.1))',
    color: 'var(--incident-resolved-color, #0dae2a)',
  },
  [OIncidentsStatus.FalsePositive]: {
    bg: 'var(--incident-false-positive-bg, rgba(163, 163, 163, 0.1))',
    color: 'var(--incident-false-positive-color, #777777)',
  },
};

export const takedownsStatusColorCoding = {
  [OTakedownStatus.Approved]: { bg: 'var(--quo-grey-75)', tooltip: '' },
  [OTakedownStatus.New]: { bg: 'var(--quo-grey-75)', tooltip: '' },
  [OTakedownStatus.Pending]: { bg: 'var(--quo-grey-75)', tooltip: 'Waiting for Provider' },
  [OTakedownStatus.Feedback]: {
    bg: 'var(--quo-yellow)',
    color: 'var(--quo-char)',
    tooltip: 'Successfully Closed',
  },
  [OTakedownStatus.Resolved]: { bg: 'var(--quo-green)', tooltip: 'Successfully Closed' },
  [OTakedownStatus.Rejected]: { bg: 'var(--quo-power-50)' },
  [OTakedownStatus.Closed]: { bg: 'var(--quo-grey-75)', tooltip: 'Unsuccessfully Closed' },
  [OTakedownStatus.InProgress]: { bg: 'var(--quo-grey-75)' },
};

export const incidentParentCategory = (incident: IncidentPageTableRecord) =>
  incident.subcategory === IncidentCategory.NewVulnerability
    ? RouterLinkIncidentParentCategory.Vulnerabilities
    : RouterLinkIncidentParentCategory.IncidentManagement;
